/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import { toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
import { HeaderToolbar } from './HeaderToolbar'

export function HeaderWrapper() {
	const { classes, attributes } = useLayout()

	return (
		<div
			id="kt_header"
			className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
			{...attributes.headerMenu}>
			<div className="custom-toolbar-width d-flex flex-row justify-content-end">
				<div className={'d-flex flex-row align-items-center justify-content-center px-10'}>
					<img
						src={toAbsoluteUrl('/media/kumopack-logo/kumopack-logo-1.png')}
						alt="Kumopack Logo 2"
						width={200}
					/>
				</div>

				<HeaderToolbar />
			</div>
		</div>
	)
}
